// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1MdTE","inputDescription":"styles_inputDescription__2Cz8G"};